'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OverlayDrawer", {
    enumerable: true,
    get: function() {
        return OverlayDrawer;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _drawerContext = require("../../contexts/drawerContext");
const _useOverlayDrawer = require("./useOverlayDrawer");
const _renderOverlayDrawer = require("./renderOverlayDrawer");
const _useOverlayDrawerStylesstyles = require("./useOverlayDrawerStyles.styles");
const OverlayDrawer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useOverlayDrawer.useOverlayDrawer_unstable)(props, ref);
    const contextValue = (0, _drawerContext.useDrawerContextValue)();
    (0, _useOverlayDrawerStylesstyles.useOverlayDrawerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerOverlayStyles_unstable')(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useOverlayDrawerStyles_unstable')(state);
    return (0, _renderOverlayDrawer.renderOverlayDrawer_unstable)(state, contextValue);
});
OverlayDrawer.displayName = 'OverlayDrawer';
